<template>
  <div id="app">
      <template v-if="pageType == '' || pageType == 'main'">
        <table style="width: 100%; background-color: #696969" cellspacing="1" cellpadding="3">
            <tr style="background-color: #e8e8e8; font-weight: bold"> 
                <td>#</td>
                <td>Date</td>
                <td>Board SN</td>
                <td>Device SN</td>
                <td>Result</td>
                <td>Tested By</td>
                <td>Extra Info</td>
            </tr>
            <template v-for="(test, index) in testList">
                <tr v-bind:key="'test_line1_'+ test.testId + '_' + index" 
                :style="{ cursor: 'pointer', color: getTextColor(test.result), backgroundColor: getBgColor(test.result), fontWeight: 'bold' }"
                @click="showLog(test.testId)"
                >
                    <td>{{ test.testId }}</td>
                    <td>{{ millisToTime(test.date) }}</td>
                    <td>{{ test.boardId }}</td>
                    <td>{{ test.deviceId }}</td>
                    <td>{{ test.result }}</td>
                    <td>{{ test.testedBy }}</td>
                    <td>{{ test.extraInfo }}</td>
                </tr>
                <tr v-bind:key="'test_line2_'+ test.testId + '_' + index" style="background-color: #e8e8e8;" v-show="test.testId == showTestId">
                    <td colspan="7" align="left">
                        <div style="max-height: 300px !important; overflow-y: scroll" v-html="test.log"></div>
                    </td>
                </tr>
            </template>
        </table>
      </template>

      <template v-if="pageType == 'approved'">
        <table style="width: 100%; background-color: #696969" cellspacing="1" cellpadding="3">
            <tr style="background-color: #e8e8e8; font-weight: bold"> 
                <td>Date</td>
                <td>Board SN</td>
                <td>Device SN</td>
                <td>Approved By</td>
            </tr>
            <template v-for="(approve, index) in approvedList">
                <tr v-bind:key="'approve_line1_'+ approve.id + '_' + index"
                :style="{ cursor: 'pointer', backgroundColor: getApproveBGColor(index), fontWeight: 'bold' }"
                 @click="showApproveExtra(approve.id)"
                 >
                    <td>{{ millisToTime(approve.date) }}</td>
                    <td>{{ approve.boardId }}</td>
                    <td>{{ approve.deviceId }}</td>
                    <td>{{ approve.approvedBy }}</td>
                </tr>
                <tr v-bind:key="'approve_line2_'+ approve.id + '_' + index" style="background-color: #e8e8e8;" v-show="true/*approve.id == showApproveId*/">
                    <td colspan="7" align="left">
                        <div style="max-height: 300px !important; overflow-y: scroll" v-html="approve.extra"></div>
                    </td>
                </tr>
            </template>
        </table>
      </template>

  </div>
</template>

<script>
var moment = require('moment');

function getQueryStringValue (key) {  
    return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
}

export default {
    data: () => ({
        testList: [],
        approvedList: [],
        showTestId: -1, 
        token: getQueryStringValue("token"),
        pageType: getQueryStringValue("page"),
        showApproveId: -1
    }),
    mounted() {
        var self = this;
        this.$nextTick(function () {
            //window.location.hostname
            if (self.pageType == "" || self.pageType == "main") {
                self.$http.get(`http://moov.pixellot.tv/api/v1/GET_ALL_TESTS`,
                {
                    headers: { 'Authorization': `${self.token}`}                
                }, 
                ).then(response => {
                    try {
                        self.testList = response.body;
                        console.log(response.body);
                    } catch (err) {

                    }
                });
            } else if (self.pageType == "approved") {
                self.$http.get(`http://moov.pixellot.tv/api/v1/GET_ALL_APPROVED`,
                {
                    headers: { 'Authorization': `${self.token}`}                
                }, 
                ).then(response => {
                    try {
                        self.approvedList = response.body;
                        console.log(response.body);
                    } catch (err) {

                    }
                });
            }
        });        
    },
    methods: {
        showLog(id) {
            if (id == this.showTestId) {
                this.showTestId = -1;
            } else {
                this.showTestId = id;
            }
        },
        showApproveExtra(id) {
            if (id == this.showApproveId) {
                this.showApproveId = -1;
            } else {
                this.showApproveId = id;
            }
        },
        millisToTime(ms) {
            console.log(ms);
            return moment.utc('1970-01-01 00:00:00').add(moment.duration(ms)).local().format('DD/MM/YYYY HH:mm:ss');            
        },
        getApproveBGColor(id) {
            if (id % 2) {
                return "#dbf5ff";
            } else {
                return "#a6e6ff";
            }
        },
        getBgColor(result) {
            switch (result) {
                case "PASSED":
                    return "#31b800";
                case "FAILED":
                    return "#b81f00";
                default:
                    return "white";
            }
        },
        getTextColor(result) {
            switch (result) {
                case "PASSED":
                    return "#000000";
                case "FAILED":
                    return "#ffffff";
                default:
                    return "black";
            }
        },        
    }
    
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
